import React, { useState, useEffect } from 'react';
import AppSidebar from './Sidebar';
import { useAuth } from '../contexts/AuthContext';
import { Client, Databases, Storage, Query } from 'appwrite';

const client = new Client();
client.setEndpoint('https://cloud.appwrite.io/v1').setProject('67fbee6a001260770104');

const databases = new Databases(client);
const storage = new Storage(client);

const DATABASE_ID = '68098bc80034d68e4e64';
const COLLECTION_ID = '68098bd900226cbeb1cd';
const BUCKET_ID = '680990d6000f00f9d400';

const MyStories = () => {
  const [stories, setStories] = useState([]);
  const [loading, setLoading] = useState(true);
  const { currentUser } = useAuth();

  useEffect(() => {
    const fetchStories = async () => {
      if (!currentUser) {
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        const response = await databases.listDocuments(
          DATABASE_ID,
          COLLECTION_ID,
          [
            Query.equal('userId', currentUser.uid),
            Query.equal('contentType', 'Story'), // use correct case
          ]
        );
        setStories(response.documents);
      } catch (error) {
        console.error('Error fetching stories:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchStories();
  }, [currentUser]);

  const getImageUrl = (imageId) => {
    if (!imageId) return null;
    try {
      return storage.getFileView(BUCKET_ID, imageId).href;
    } catch (error) {
      console.error('Error getting image URL:', error);
      return null;
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div>Loading...</div>
      </div>
    );
  }

  if (!currentUser) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div>Please log in to view your stories.</div>
      </div>
    );
  }

  return (
    <div className="flex">
      <div className="sticky top-0 h-screen">
        <AppSidebar user={currentUser} />
      </div>
      <div className="ml-20 md:ml-0 p-6 bg-gray-100 min-h-screen flex-1">
        <h1 className="text-2xl font-bold mb-4">My Stories</h1>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {stories.length > 0 ? (
            stories.map((story) => (
              <div key={story.$id} className="bg-white rounded-lg shadow-md overflow-hidden">
                {story.imageId && (
                  <img
                    src={getImageUrl(story.imageId)}
                    alt={story.title || 'Story image'}
                    className="h-48 w-full object-cover"
                    onError={(e) => {
                      e.target.src = 'https://via.placeholder.com/400x200?text=Image+Not+Found';
                    }}
                  />
                )}
                <div className="p-4">
  <h2 className="text-xl font-bold mb-2">{story.title || 'Untitled Story'}</h2>

  {/* Category Badge */}
  {story.category && (
    <div className="mb-2">
      <span className="bg-blue-100 text-blue-800 text-xs font-medium px-2.5 py-0.5 rounded-full">
        {story.category}
      </span>
    </div>
  )}

  {/* Approval Status */}
  <div className="mb-2">
    {story.isApproved ? (
      <span className="text-green-600 text-sm font-semibold">Approved ✅</span>
    ) : (
      <span className="text-red-500 text-sm font-semibold">Not Approved ❌</span>
    )}
  </div>

  <p className="text-gray-700 whitespace-pre-line">
    {story.content || 'No content available'}
  </p>
</div>

              </div>
            ))
          ) : (
            <div className="col-span-full text-center py-8">
              <p className="text-gray-500">No stories found.</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default MyStories;
